import React from 'react'

function Pge() {
  return (
    <div>Pge</div>
  )
}

export default Pge